// Web stub for react-native-google-mobile-ads — the SDK is iOS/Android only.
// `ads.ts` early-returns when `IS_WEB`, so these stubs are never invoked.
const noop = () => {};
const noopUnsub = () => () => {};

const RewardedAd = {
  createForAdRequest: () => ({
    load: noop,
    show: noop,
    addAdEventListener: noopUnsub,
  }),
};

const AdsConsent = {
  requestInfoUpdate: async () => ({ isConsentFormAvailable: false }),
  loadAndShowConsentFormIfRequired: async () => {},
};

export default () => ({ initialize: async () => {} });
export { RewardedAd, AdsConsent };
export const RewardedAdEventType = { LOADED: 'loaded', EARNED_REWARD: 'earned' };
export const AdEventType = { ERROR: 'error', CLOSED: 'closed' };
export const TestIds = { REWARDED: 'test-rewarded' };
